import carousel1 from "./Images/carousel1.jpg";
import carousel2 from "./Images/carousel2.jpeg";
import carousel3 from "./Images/carousel3.jpeg";


function HomePage(){
    const opacity = {
        opacity : 0.8
    }
    return(
        <>
            <div id="carouselExampleCaptions" className="carousel slide mt-0">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={carousel1} height="650px" style={opacity} className="d-block w-100" alt="..."/>
                        <div className="carousel-caption d-none d-md-block">
                            <h5 className="display-1 fw-bold text-info">Lifelong Learning</h5>
                            <p className="fs-3 px-5 headingCls">Experts across seven departments will expand understanding of the natural world and its intersections with human society</p>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img src={carousel2} height="650px" style={opacity} className="d-block w-100" alt="..."/>
                        <div className="carousel-caption d-none d-md-block">
                            <h5 className="display-1 fw-bold text-warning">Campus Life</h5>
                            <p className="fs-3 px-5 headingCls">Interdisciplinary institutes will bring together versatile teams to tackle critical challenges in energy, and sustainable societies</p>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img src={carousel3} height="650px" style={opacity} className="d-block w-100" alt="..."/>
                        <div className="carousel-caption d-none d-md-block">
                            <h5 className="display-1 fw-bold text-danger">Bridging fields</h5>
                            <p className="fs-3 px-5 headingCls">A new Sustainability Accelerator will draw expertise from across and beyond the university to co-create and scale solutions</p>
                        </div>
                    </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
            
        </>
    )
}
export default HomePage